import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './actions';
import { withErrorBoundaryTrigger } from 'sharedComponents/ErrorBoundary';
import DeleteAssetComponent from './DeleteAssetComponent';
import { getModel } from './selectors';

const DeleteAssetContainer = (props) => {

	return <div id='delete-asset-tab-container'>
			<DeleteAssetComponent {...props} />
	</div>;
};

const mapStateToProps = (state) => {
	const model = getModel(state);
	return {
		model
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		actions: bindActionCreators(actions, dispatch)
	};
};

const deleteAssetContainerWithErrorBoundaryTrigger = withErrorBoundaryTrigger(DeleteAssetContainer);
const DeleteAssetContainerConn = connect(
	mapStateToProps,
	mapDispatchToProps
)(deleteAssetContainerWithErrorBoundaryTrigger);

export default DeleteAssetContainerConn;
